module.exports = __webpack_public_path__ + "img/newspaper.bc1a1bfb.jpg";